import * as React from 'react'
import { TellUsWhyPage } from './pages/TellUsMorePage'
import {UndoOverlayMainPage} from "./pages/UndoOverlayMainPage";
import {HideThisOutput} from "@utils";

interface UndoOverlayProps extends HideThisOutput {
    onUndo: (out: HideThisOutput) => void
    onHideThis?: () => void
    hasTimer: boolean
}


interface UndoOverlayState {
    isTellUsWhy: Boolean
}

export class UndoOverlay extends React.Component<UndoOverlayProps, UndoOverlayState> {

    constructor(props: UndoOverlayProps) {
        super(props);
        this.state = {
            isTellUsWhy: false
        }
    }


    render() {
        return this.state.isTellUsWhy ?
            (
                <TellUsWhyPage action={this.props.tellUsWhyAction}
                               onExit={() => this.setState({isTellUsWhy: false})}
                               onSuccess={() => setTimeout(() => this.props.onHideThis(),1000)}
                 />
            ) :
            (
                <UndoOverlayMainPage
                    {...this.props}
                    onTellUsWhy={() => this.setState({ isTellUsWhy: true })}
                    onUndo={this.props.onUndo}
                    onTimerEnd={this.props.onHideThis}
                />
            )
    }
}